import { DateTime } from "luxon";
import { AppApi } from "../api/AppApi";
import { RootState } from "../store/index";
import { Company } from "./companyTypes";

export interface ThunkMiddlewareExtraType {
  api: (state: any) => AppApi;
}

export interface ThunkApiType {
  extra: ThunkMiddlewareExtraType;
  state: RootState;
}

export enum LoadState {
  INIT,
  LOADING,
  LOADED,
  ERROR,
}

export interface User {
  id: string;
  accessToken?: string;
  idToken?: string;
  refreshToken?: string;
  lastName?: string;
  firstName?: string;
  username?: string;
  email?: string;
  role?: Role;
  enabled?: boolean;
  sub?: string;
  imageUrl?: string;
  createdAt?: Date;
  updatedAt?: Date;
  phoneNumber?: string;
  company?: CompanyWithRole;
  identityVerified: boolean;
  bio?: string;
  validationImages?: { fileId: number; imageUrl: string }[];
  serviceDateAgreement?: DateTime;
}

export interface CompanyWithRole extends Company {
  companyRole: CompanyRole;
}

export enum CompanyRole {
  MANAGER = "MANAGER",
  EMPLOYEE = "EMPLOYEE",
}

export interface Employee extends User {
  companyRole: CompanyRole;
}

export enum UserRoles {
  USER = "user",
  EMPLOYEE = "employee",
  MANAGER = "manager",
  ADMIN = "admin",
}

export interface FirstAndLastNameAndPhone {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

export interface AddUserReq {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  dob?: Date;
  gender?: Gender;
}

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export interface WaitingListEntry {
  email: string;
  name?: string;
  createdAt: Date;
}

export interface BasicTableHeader<T> {
  key: T;
  value: string | number;
}
